module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_3016.e1666aaf.png";